export default __webpack_public_path__ + "static/media/Mark-5-HUD-05.46e5dbf0.jpg";